import StorageService from '@/services/common/storage.service';
import ApiService from '@/services/common/api.service';
import UserManagementService from '@/services/admin/user.service';
import router from '../../router';
import { Role } from '@/helpers/role';
import Utils from '@/helpers/utils';
import store from '../../store';


export const AuthService = {
    login,
    logout,
    changePassword,
    doLogout,
    mfaLogin,
};

// 初回ログイン
async function login (username, password, placeId, rememberMe, clickChangePass) {
    try {
        StorageService.removeToken();

        let requestData = {
            method: 'post',
            url: `${process.env.API_URL}/login`,
            data: {
                username: username,
                password: password,
                type: "password",
                branchCode: placeId,
            },
        };
        // Do login
        let response = await ApiService.customRequest(requestData);
        if (response) {
            // Save remember me
            if (rememberMe) {
                let remember = {
                    rememberMe: rememberMe,
                    username: username,
                    password: password,
                    placeId: placeId,
                };
                StorageService.saveRememberMe(JSON.stringify(remember));
            } else {
                StorageService.removeRememberMe();
            }

            if (response && response.data.mfaRequired) {
                if (clickChangePass) StorageService.saveClickChangePass(clickChangePass);
                const secretKey = response.data.secret_key;
                const url = response.data.url;
                if (secretKey) {
                    if (Utils.checkIsMobile()) {
                        store.commit('setLoginInfo', {
                            secretKey: secretKey
                        })    
                    } else {
                        store.commit('setLoginInfo', {
                            url: url
                        })   
                    }
                    router.push({path: '/login/mfa/first', query: {username: username, placeId: placeId}});   
                } else {
                    router.push({path: '/login/mfa', query: {username: username, placeId: placeId}});
                }
            } else {
                if (!response.data.mfaFlag) {
                    return response;
                } else {
                    verifiedLoginInfo(response.data.accessToken, response.data.refreshToken, response.data.passwordUpdateRequired, clickChangePass, username, placeId);
                    return response;
                }
            }   
        }
    } catch (error) {
        return error;
    }
}

// ログイン情報検証OK時処理
async function verifiedLoginInfo (accessToken, refreshToken, passwordUpdateRequired, clickChangePass, username, placeId ) {
    // Save access token
    if (accessToken) {
        StorageService.saveToken(accessToken);
    }
    // Save refresh token
    if (refreshToken) {
        StorageService.saveRefreshToken(refreshToken);
    }
    // get and save currency
    // getCurrency();
    const role = StorageService.getUserRole();
    if (role == Role.PwReset.id) {
        if (Utils.checkIsMobile()) {
            StorageService.saveSpLoginPwRest(true)
            await logout();
        }
    }
    if (passwordUpdateRequired && passwordUpdateRequired == true) {
        StorageService.saveLoginVal(JSON.stringify({username: username, placeId: placeId ? placeId : ""}));
        router.push({path: '/changepassword', query: {username: username, placeId: placeId}}).catch(()=>{});;
    } else if (clickChangePass) {
        StorageService.saveLoginVal(JSON.stringify({username: username, placeId: placeId ? placeId : ""}));
        StorageService.saveClickChangePass(clickChangePass);
        router.push({path: '/changepassword', query: {username: username, placeId: placeId}}).catch(()=>{});;
    } else {
        // get and save currency
        await UserManagementService.getUser(placeId);
        if (role == Role.PwReset.id) {
            router.push('/admin/users');
        } else {
            getCurrency();
            const role = StorageService.getUserRole();
            if (role == Role.Cooperator.id && accessToken) {
                const token = StorageService.getToken();
                const decodedToken = decodeToken(token);
                StorageService.saveUserCashKeyName(decodedToken.dmos_cash_key);
                router.push({path: `/tour/after-input?search=${decodedToken.tour_number}`});
            } else {
                router.push('/tour/input');
            }
        }
    }    
}

// トークンをデコードする
function decodeToken(token) {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const encodeURI = encodeURIComponent(atob(base64))
    const decodeString = decodeURIComponent(encodeURI)
    return JSON.parse(decodeString)
}

// ２段階目
async function mfaLogin(username, placeId, mfaCode, clickChangePass) {
    try {
        if (!clickChangePass) {
            StorageService.removeToken();
            StorageService.removeRefreshToken();
        }
        let requestData = {
            method: 'post',
            url: `${process.env.API_URL}/login`,
            data: {
                username: username,
                mfaCode: mfaCode,
                type: "mfa",
                branchCode: placeId,
            },
        };
        // Do login
        let response = await ApiService.customRequest(requestData);
        if (response) {
            verifiedLoginInfo(response.data.accessToken, response.data.refreshToken, response.data.passwordUpdateRequired, clickChangePass, username, placeId);
            return response;
        }

        store.commit('clearLoginInfo');
    } catch (error) {
        return error;
    }
}


async function logout () {
    try {
        let requestData = {
            method: 'post',
            url: `${process.env.API_URL}/logout`,
        };
        let response = await ApiService.customRequest(requestData);
        if (response) {
            // remove user from local storage to log user out
            StorageService.removeToken();
            StorageService.removeRefreshToken();
            StorageService.removeTour();
            StorageService.removeCurrency();
            StorageService.removeCashId();
            StorageService.removeCurrencyId();
            StorageService.removeCashIdServer();
            StorageService.removeTourIdServer();
            StorageService.removeUser();
            StorageService.removeOcr();
            StorageService.clearPreInputVoucher();
            StorageService.removeCashName();
            StorageService.removeCashKeyName();
            StorageService.removeUserCashKeyName();
            StorageService.removeLoginVal();
            StorageService.removeClickChangePass();
            router.push('/login').catch(()=>{});
        }
    } catch (error) {
        return error;
    }
}

async function doLogout () {
    StorageService.removeToken();
    StorageService.removeRefreshToken();
    StorageService.removeTour();
    StorageService.removeCurrency();
    StorageService.removeCurrencyId();
    StorageService.removeCashId();
    StorageService.removeCashIdServer();
    StorageService.removeTourIdServer();
    StorageService.removeUser();
    StorageService.removeOcr();
    StorageService.clearPreInputVoucher();
    StorageService.removeCashName();
    StorageService.removeCashKeyName();
    StorageService.removeUserCashKeyName();
    StorageService.removeLoginVal();
    StorageService.removeClickChangePass();
    router.push('/login').catch(()=>{});
}

async function changePassword (password, username, placeId, clickChangePass) {
    try {
        let requestData = {
            method: 'put',
            url: `${process.env.API_URL}/passwd`,
            data: {
                password: password,
            },
        };
        let response = await ApiService.customRequest(requestData);
        if (response) {
            let loginVal = JSON.parse(StorageService.getLoginVal());
            if (!clickChangePass) {
                StorageService.removeToken();
                StorageService.removeRefreshToken();
            }

            let login = {
                method: 'post',
                url: `${process.env.API_URL}/login`,
                data: {
                    username: loginVal.username,
                    password: password,
                    type: "password",
                    branchCode: loginVal.placeId,
                },
            };
            // Do login
            let loginRes = await ApiService.customRequest(login);
            if (loginRes) {
                if (loginRes.data.mfaRequired && !clickChangePass) {
                    const remember = JSON.parse(StorageService.getRememberMe());
                    if (remember) {
                        const newRemember = {
                            rememberMe: remember.rememberMe,
                            username: remember.username,
                            password: password,
                            placeId: remember.placeId,
                        };
                        StorageService.saveRememberMe(JSON.stringify(newRemember));
                    }
                    const secretKey = loginRes.data.secret_key;
                    const url = loginRes.data.url;
                    if (secretKey) {
                        if (Utils.checkIsMobile()) {
                            store.commit('setLoginInfo', {
                                secretKey: secretKey
                            })
                        } else {
                            store.commit('setLoginInfo', {
                                url: url
                            })
                        }
                        router.push({ path: '/login/mfa/first', query: { username: username, placeId: placeId } });
                    } else {
                        router.push({ path: '/login/mfa', query: { username: username, placeId: placeId } });
                    }
                } else {
                    // Save access token
                    if (loginRes.data.accessToken) {
                        StorageService.saveToken(loginRes.data.accessToken);
                    }
                    // Save refresh token
                    if (loginRes.data.refreshToken) {
                        StorageService.saveRefreshToken(loginRes.data.refreshToken);
                    }
                    let userRole = StorageService.getUserRole();
                    ApiService.setHeader();
                    if (!clickChangePass) {
                        StorageService.removeToken();
                        StorageService.removeRefreshToken();
                    }
                    StorageService.saveUserRole(userRole);
                    // get and save currency
                    await UserManagementService.getUser(loginVal.placeId);
                    StorageService.removeLoginVal();
                    const role = StorageService.getUserRole();
                    if (role == Role.PwReset.id) {
                        if (Utils.checkIsMobile()) {
                            StorageService.saveSpLoginPwRest(true)
                            await logout();
                        } else {
                            const remember = JSON.parse(StorageService.getRememberMe());
                            if (remember) {
                                const newRemember = {
                                    rememberMe: remember.rememberMe,
                                    username: remember.username,
                                    password: password,
                                    placeId: remember.placeId,
                                };
                                StorageService.saveRememberMe(JSON.stringify(newRemember));
                            }
                            router.push('/admin/users');
                        }
                    } else {
                        getCurrency();
                        const remember = JSON.parse(StorageService.getRememberMe());
                        if (remember) {
                            const newRemember = {
                                rememberMe: remember.rememberMe,
                                username: remember.username,
                                password: password,
                                placeId: remember.placeId,
                            };
                            StorageService.saveRememberMe(JSON.stringify(newRemember));
                        }
                        const role = StorageService.getUserRole();
                        if (role == Role.Cooperator.id) {
                            const token = StorageService.getToken();
                            const decodedToken = decodeToken(token);
                            StorageService.saveUserCashKeyName(decodedToken.dmos_cash_key);
                            router.push({ path: `/tour/after-input?search=${decodedToken.tour_number}` });
                        } else {
                            router.push('/tour/input');
                        }
                    }
                }
            }
        }
    } catch (error) {
        return error;
    }
}

async function getCurrency () {
    try {
        let requestData = {
            method: 'get',
            url: `${process.env.API_URL}/currency`,
        };
        let response = await ApiService.customRequest(requestData);
        if (response) {
            StorageService.saveCurrency(JSON.stringify(response.data));
        }
    } catch (error) {
        return error;
    }
}



// WEBPACK FOOTER //
// ./src/services/common/auth.service.js